import React, { useState } from 'react'
import AllergyDetails from '../ConsultationNotes/VitalTabs/MedicalHistory/AllergyDetails'
import ChronicCondition from '../ConsultationNotes/VitalTabs/MedicalHistory/ChronicCondition'
import { FaAllergies, FaHeartbeat } from 'react-icons/fa'

const ChCoAndAllDetails = ({ appointmentDetails }) => {
    const [showAllergy, setShowAllergy] = useState(false)
    const [showChronic, setShowChronic] = useState(false)

    const handleCancel = () => {
        setShowAllergy(false)
        setShowChronic(false)
    }

    return (
        <>
            <button title='Allergy Details'
                onClick={() => setShowAllergy(true)}
                className="p-2 text-sm bg-blue-500 text-white rounded-md hover:bg-blue-600 transition  w-8 h-8"
            >
                <FaAllergies size={16} />
            </button>

            <button
                title='Chronic conditions'
                onClick={() => setShowChronic(true)}
                className="p-2 text-sm bg-green-500 text-white rounded-md hover:bg-green-600 transition ml-2 w-8 h-8"
            >
                <FaHeartbeat size={16} />
            </button>

            {showAllergy && (
                <div className="fixed inset-0 z-50 flex items-center justify-center">

                    <div
                        className="absolute inset-0 bg-black bg-opacity-50"
                        onClick={handleCancel}
                    />

                    <div className="relative bg-white rounded-lg shadow-lg w-full max-w-2xl mx-4 p-6">
                        <AllergyDetails permissionData={"Y"} />
                    </div>
                </div>
            )}

            {showChronic && (
                <div className="fixed inset-0 z-50 flex items-center justify-center">

                    <div
                        className="absolute inset-0 bg-black bg-opacity-50"
                        onClick={handleCancel}
                    />

                    <div className="relative bg-white rounded-lg shadow-lg w-full max-w-2xl mx-4 p-6">
                        <ChronicCondition permissionData={"Y"} />
                    </div>
                </div>
            )}
        </>
    )
}

export default ChCoAndAllDetails